<template>
  <div>
    <dv-scroll-board
      style="width: 100%; height: 230px; padding: 0 20px"
      :config="config"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: ['司机名称', '驾龄', '货品重量', '路程', '车辆'],
        data: [
          ['张三', '5', '2000', '100', '京A12345'],
          ['李四', '3', '1500', '50', '京B67890'],
          ['王五', '8', '3000', '200', '沪C24680'],
          ['赵六', '2', '1800', '80', '粤D13579'],
          ['刘七', '6', '2500', '150', '浙E97531'],
          ['周八', '4', '1200', '30', '苏F24689'],
          ['钱九', '7', '2800', '180', '皖G13579'],
          ['吴十', '1', '1000', '10', '鲁H24680'],
          ['孙十一', '9', '3500', '250', '豫J24681'],
          ['何十二', '5', '2200', '120', '鄂K24682'],
          ['郑十三', '3', '1600', '60', '川L24683'],
          ['王十四', '6', '2400', '130', '湘M24684'],
          ['赵十五', '2', '1900', '90', '云N24685'],
          ['刘十六', '4', '1300', '40', '陕P24686'],
          ['杨十七', '8', '3100', '220', '甘Q24687'],
          ['许十八', '1', '1100', '20', '青R24688'],
          ['孙十九', '7', '2700', '170', '新S24689'],
          ['黄二十', '9', '3300', '240', '藏T24690'],
          ['林二十一', '5', '2100', '110', '宁U24691'],
        ],
        rowNum: 5, //表格行数
        headerBGC: 'rgba(41, 105, 177,0.3)', //表头
        oddRowBGC: 'transparent', //奇数行
        evenRowBGC: 'transparent', //偶数行
        hoverPause: false,
        // index: true,
        columnWidth: [153, 153, 153, 153, 153],
        align: ['center', 'center', 'center', 'center', 'center'],
      },
    }
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="scss"></style>
